import styles from './EventsPage.module.scss';

import { PageHeader } from '../../../components/PageHeader/PageHeader';
import { PageLayout } from '../../../components/PageLayout/PageLayout';
import { PagePagination } from '../../../components/PagePagination/PagePagination';

import { useState } from 'react';
import { EventCard } from '../../../components/EventCard/EventCard';
import { EventsFilterWidget } from '../../../components/EventsFilterWidget/EventsFilterWidget';
import { Loader } from '../../../components/Loader/Loader';
import { DropdownOption, IEventCard } from '../../../types/types';
import Pagination from '../../StaffPages/SupportList/Pagination';

import { useFetchEvents } from '../../../hooks/useFetchEvents';

interface EventsPageProps {
    isArchive?: boolean;
}

export const EventsPage = ({ isArchive = false }: EventsPageProps) => {
    // Пагинация и фильтры
    const [page, setPage] = useState<number>(1);
    const initialState = { value: '', label: 'Все' };
    const [format, setFormat] = useState<DropdownOption>(initialState);
    const [place, setPlace] = useState<DropdownOption>(initialState);
    const [searchValue, setSearchValue] = useState<string>('');

    const title = isArchive ? 'Архив событий' : 'Мероприятия';

    const { eventsData: events, isLoading, totalCount: paginationArr } = useFetchEvents({
        page,
        size: 10,
        format: format.value || undefined,
        place: place.value || undefined,
        search: searchValue || undefined,
        // мероприятия вместе с новостями-мероприятиями: в архиве прошедшие,
        // на обычной странице предстоящие
        feed: isArchive ? 'archive' : 'upcoming',
    });

    return (
        <PageLayout>
            <div className={styles.eventspage}>
                <div className={styles.eventspage__wrapper}>
                    <PagePagination linkName={title} />
                    <PageHeader title={title} />
                    <div className={styles.eventspage__container}>
                        <EventsFilterWidget
                            setFormat={setFormat}
                            format={format}
                            setPlace={setPlace}
                            place={place}
                            setSearchValue={setSearchValue}
                        />

                        {isLoading ? (
                            <div className={styles.eventspage__loader}>
                                <Loader />
                            </div>
                        ) : (
                            <div className={styles.eventspage__cards}>
                                {events && <EventsList events={events} />}
                            </div>
                        )}

                        <Pagination
                            list={{
                                page_count: paginationArr || 1,
                                current_page: page,
                            }}
                            handlePagination={(p) => setPage(p)}
                            isLoading={isLoading}
                        />
                    </div>
                </div>
            </div>
        </PageLayout>
    );
};

interface EventsListProps {
    events: IEventCard[];
}
export const EventsList = ({ events }: EventsListProps) => {
    return (
        <div className={styles.EventsList}>
            {events.map((event) => (
                <EventCard event={event} key={event.id} />
            ))}
        </div>
    );
};
